import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';

import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';

import ImageView from './Image';
import UnknownView from './Unknown';
import JournalView from './Journal';
import StatusView from './Status';
import LiteratureView from './Literature';
import TierView from './Tier';
import CommissionView from './Commission';
import PollView from './Poll';
import EditorDeviationLink from '../MonoView/_partials/DeviationLink';

export interface Props {
  deviation: PapiDeviation;
  containerWidth: number;
  width: number;
  height?: number;
  crop?: 'fill' | 'contain' | 'cover';
  link?: string;
  inEditor?: boolean;
}

const InlineView: React.FC<Props> = props => {
  let View;
  switch (getDeviationType(props.deviation)) {
    // these types all have guaranteed thumb image
    case DeviationTypes.IMAGE:
    case DeviationTypes.PDF:
    case DeviationTypes.FILM:
      View = ImageView;
      break;
    case DeviationTypes.LITERATURE:
      View = LiteratureView;
      break;
    case DeviationTypes.STATUS:
      View = StatusView;
      break;
    case DeviationTypes.JOURNAL:
      View = JournalView;
      break;
    case DeviationTypes.TIER:
      View = TierView;
      break;
    case DeviationTypes.COMMISSION:
      View = CommissionView;
      break;
    case DeviationTypes.POLL:
      View = PollView;
      break;
    default:
      View = UnknownView;
  }

  if (props.inEditor) {
    return <View {...props} />;
  }

  return (
    <EditorDeviationLink link={props.link} deviation={props.deviation}>
      <View {...props} />
    </EditorDeviationLink>
  );
};
InlineView.displayName = 'InlineView';

export default InlineView;
